import { Alert, Button } from 'antd'
import { toast } from 'react-toastify'

import Loading from '@/components/Loading'
import { useUpdateURLSearchParams } from '@/hooks/useQuery'
import useSearchParams from '@/hooks/useSearchParams'
import { useDeleteTagClientById } from '@/queries/customers/useDeleteTagClientById'
import { useLoadTagsClient } from '@/queries/customers/useLoadTagsClient'
import Modal from '@/ui/Modal'

export const ConfirmDeleteTagClientModal = () => {
  const searchParams = useSearchParams()
  const updateParams = useUpdateURLSearchParams()

  const {
    deleteTagClientById,
    isLoading: isLoadingDelete,
    isError,
  } = useDeleteTagClientById()

  const deleteTagId = searchParams.get('deleteTag') || ''

  const { data: badgeData = [], isLoading } = useLoadTagsClient()

  const getTagById = badgeData?.find((item) => String(item.id) === deleteTagId)

  const onConfirm = async () => {
    try {
      await deleteTagClientById(deleteTagId)
      updateParams(['deleteTag', undefined])
      toast.success('Tag deleted')
    } catch (error) {
      toast.error('Error deleting tag')
    }
  }

  return (
    <Modal
      open
      footer={() => undefined}
      title="Delete Tag"
      width={{
        xs: '90%',
        sm: '80%',
        md: '70%',
        lg: '50%',
        xl: '40%',
        xxl: '30%',
      }}
    >
      {isLoadingDelete && <Loading className="!h-48" />}

      {!isLoading && !isLoadingDelete && isError && (
        <p>This form doesn't exist.</p>
      )}

      {!isLoading && !isLoadingDelete && !isError && (
        <>
          <Alert
            showIcon
            className="my-4"
            description={
              <div className="flex flex-col">
                <span>
                  This tag will be removed from all patient it is associated
                  with.
                </span>
                <span className="font-bold">
                  <small>●</small> {getTagById?.name}
                </span>
              </div>
            }
            message="Are you sure you want to permanently delete this tag?"
            type="warning"
          />
          <div className="mt-8 flex w-full justify-end gap-2">
            <Button onClick={() => updateParams(['deleteTag', undefined])}>
              Cancel
            </Button>
            <Button danger onClick={onConfirm} type="primary">
              Delete
            </Button>
          </div>
        </>
      )}
    </Modal>
  )
}
